// extracted by mini-css-extract-plugin
export default {"Options":"RemoveColumnDataModal_Options__rMhkD"};